<div class="p-3 bg-opacity-10" [ngClass]="hasError ? 'bg-danger' : 'bg-light'">
  @if (!loading && noData) {
    <div class="d-flex flex-column align-items-center text-center">
      <span class="material-symbols-outlined saas-icon fs-3 text-gray"
        >error</span
      >
      {{ message }}
    </div>
  }
  @if (!loading && hasError) {
    <div class="d-flex flex-column align-items-center text-center gap-3">
      <span class="material-symbols-outlined saas-icon fs-3 text-danger"
        >error</span
      >
      <span class="fs-6">{{ message }}</span>
      @if (showRetry) {
        <button
          pButton
          type="button"
          label="Retry"
          class="p-button-outlined text-danger"
          (click)="handleRetry()"></button>
      }
    </div>
  }
  <div class="text-center">
    @if (loading) {
      <p-progressSpinner
        strokeWidth="4"
        fill="var(--surface-ground)"
        animationDuration="1s">
      </p-progressSpinner>
    }
  </div>
</div>
